import { Avatar as MantineAvatar, type AvatarProps as MantineAvatarProps } from '@mantine/core';
import React from 'react';

export interface AvatarProps extends Omit<MantineAvatarProps, 'src'> {
    src?: string | null;
    onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const Avatar = ({ src, size = 'sm', color = 'initials', onClick, ...props }: AvatarProps) => {
    return (
        <>
            {src ? (
                <MantineAvatar src={src} {...props} size={size} onClick={(e) => onClick?.(e)} />
            ) : (
                <MantineAvatar {...props} size={size} color={color} onClick={(e) => onClick?.(e)} />
            )}
        </>
    );
};

export default Avatar;
